import axios from 'axios';

export const listPublicPlans = () => axios.get('/api/public/sales/plans');
export const startSalesContract = (leadId, planId, implementationOwnerId) => (
  axios.post(`/api/sales/leads/${leadId}/contracts`, { plan_id: planId, implementation_owner_id: implementationOwnerId || null })
);
export const getSalesContract = (uuid) => axios.get(`/api/public/contratacoes/${uuid}`);
export const updateSalesContractCustomer = (uuid, data) => (
  axios.put(`/api/public/contratacoes/${uuid}/customer`, data)
);
export const createSalesContractCheckout = (uuid, kind) => (
  axios.post(`/api/public/contratacoes/${uuid}/checkout/${kind}`)
);
export const activateSalesContract = (uuid, data) => (
  axios.post(`/api/public/contratacoes/${uuid}/activate`, data)
);
